import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import {styles} from "assets/jss/registration-state.jsx";


class RegistrationState extends React.Component {

  render() {
    const {classes, color, designation} = this.props;
    return <span className={classes.wrapper} style={{backgroundColor: color}}>{designation}</span>;
  }
}

export default withStyles(styles)(RegistrationState);
